import { useNavigate } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import { useSession } from "@/contexts/SessionContext";
import { superApi } from "@/api/endpoints/super";
import { authStorage } from "@/lib/auth-storage";

export function ImpersonationBanner(): JSX.Element | null {
  const { isImpersonating, impersonatorEmail, me } = useSession();
  const navigate = useNavigate();

  const endImpersonation = useMutation({
    mutationFn: () => {
      const sessionId = me?.impersonation_session_id;
      if (!sessionId) return Promise.resolve({ ok: true } as const);
      return superApi.endImpersonation(sessionId);
    },
    onSuccess: () => {
      authStorage.clear();
      navigate({ to: "/login" });
    },
  });

  if (!isImpersonating) return null;
  return (
    <div className="imp-banner" role="alert" data-testid="impersonation-banner">
      <span className="pulse" />
      <strong style={{ letterSpacing: "0.08em" }}>IMPERSONATION ACTIVE</strong>
      <span style={{ opacity: 0.85 }}>
        · signed in as {me?.email} by {impersonatorEmail ?? "super admin"}
      </span>
      <button onClick={() => endImpersonation.mutate()} data-testid="end-impersonation">
        END SESSION
      </button>
    </div>
  );
}
